import React from 'react';
import { Typography, Stack, Paper, MarkdownRender } from '@gogame/components';

import { TYPE_USER, TYPE_BOT } from 'components/AIChatbot';

const Message = ({ message }) => {
  const isProcessingMessage = message.id === 0;

  switch (message.type) {
    case TYPE_USER:
      return (
        <Stack
          alignItems={'end'}
          component={'article'}
          sx={{ m: 1, maxWidth: '80%', justifySelf: 'flex-end' }}
        >
          <Paper
            elevation={0}
            sx={{
              bgColor: 'action.hover',
              py: 1,
              px: 2,
              borderRadius: 4,
              borderTopRightRadius: '4px',
            }}
          >
            <Typography>{message.text}</Typography>
          </Paper>
        </Stack>
      );
    case TYPE_BOT:
      let normalizedText = message.text || 'Thinking...';
      return (
        <Stack component={'article'} sx={{ m: 1 }}>
          <Typography color={'text.primary'}>
            <MarkdownRender value={normalizedText} />
          </Typography>
        </Stack>
      );
    default:
      return null;
  }
};
export default Message;
